import { render, staticRenderFns } from "./JinNangPanel.vue?vue&type=template&id=1cfb2b2e&scoped=true"
import script from "./JinNangPanel.vue?vue&type=script&lang=js"
export * from "./JinNangPanel.vue?vue&type=script&lang=js"
import style0 from "./JinNangPanel.vue?vue&type=style&index=0&id=1cfb2b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb2b2e",
  null
  
)

export default component.exports